import { ca } from '@cian/analytics';

export type TBannerLocation =
 'after_pagination' |
 'infinite' |
 'before_pagination' |
 'before_pagination_step2' |
 'after_similar';

export const trackBannerShow = () => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Show',
    label: 'Banner',
    banner_location: 'after_similar',
  });
};

export const trackOpenSmsPopup = (ishomeowner: boolean) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Open',
    label: 'SMS',
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackVerifyPhone = (ishomeowner: boolean) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_confirm',
    label: 'SMS',
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackPhoneVerificationSuccess = (ishomeowner: boolean) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'SMS',
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackSendFormSuccess = (ishomeowner: boolean) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'Page',
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackVerificationPhoneError = (ishomeowner: boolean) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Wrong_code',
    label: 'SMS',
    selected_user_type: ishomeowner ? 'owner' : 'searcher',
  });
};

export const trackChangedUserType = (userType: string) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: userType === 'homeowner' ? 'Change_to_owner' : 'Change_to_searcher',
    label: 'Banner',
    banner_location: 'after_similar',
  });
};

export const trackSendFormClick = (userType: string) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click_to_send',
    label: 'Page',
    selected_user_type: userType === 'homeowner' ? 'owner' : 'searcher',
    banner_location: 'after_similar',
  });
};
